import { useState } from 'react';
import NumberFormat from 'react-number-format';
import { KeyTypes, cartActionTypes, searchActionTypes } from '../../app/enums'
import { Typography, Grid, Button, Select, MenuItem, FormControl, OutlinedInput } from '@material-ui/core';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import { useSearchContext } from '../../context/SearchContext';
import { useCartContext } from '../../context/CartContext';
import { Carts } from '../../api/api';
import { SearchType } from '../../models/search.interface';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { CartItem, VehicleInfo } from '../../models/cart.interface';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    gridLine: {
      flexGrow: 1,
      margin: theme.spacing(1, 0, 1),
    },
    button: {
      margin: theme.spacing(0, 0, 0, 1),
    },
    select: {
      padding: '0px 0px 0px',
      display: 'inline'
    },
    selectInput: {
      padding: "4px 4px"
    },
    gridSpacer: {
      minHeight: '12px',
    },
  }),
);

export interface ISearchResultType {
  searchResult: SearchType,
  vin: string,
  clearSearch: () => void
}

export const SearchResults = ({
  searchResult, vin, clearSearch
}: ISearchResultType) => {
  const cart = useCartContext();
  const search = useSearchContext();
  const classes = useStyles();
  const [ qty, setQty] = useState(1)

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setQty(event.target.value as number);
  };

  const handleCancel = () => {
    clearSearch();
  };

  const handleButtonClick = () => {
    Carts.addCartItem(cart.state.cartId, searchResult.id, qty)
      .then((item) => {
        const vehicleInfo: VehicleInfo = {
          vin: vin,
          year: searchResult.year,
          make: searchResult.make,
          model: searchResult.model,
        }

        const cartItem:CartItem = {
          cartId: item.cartId,
          cartItemId: item.id,
          searchId: searchResult.id,
          keyType: item.keyType,
          price: item.price,
          quantity: qty,
          vehicleInfo: vehicleInfo
        }
        
        cart.dispatch({type: cartActionTypes.ADD_ITEM, item: cartItem})
    })

    search.dispatch({type: searchActionTypes.HIDE_ADD_TO_CART})
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 600 }}>
            {searchResult.year} {searchResult.make} {searchResult.model}
          </Typography>
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between" className={classes.gridLine}> 
        <Grid item xs={6}>
          <Typography> 
            {KeyTypes[searchResult.keyType as keyof typeof KeyTypes] }
          </Typography>    
        </Grid>
        <Grid item xs={4}>
          <Grid container 
            alignItems="center"
            justifyContent="space-evenly" 
            className={classes.button}    
          > 
            <Typography>
              <NumberFormat 
                value={searchResult.price}
                displayType={'text'} 
                thousandSeparator={true} 
                prefix={'$'} 
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </Typography>
            <FormControl variant='outlined'>
              <Select
                id="quantity"
                value={qty}
                onChange={handleChange}
                className={classes.select}
                input={<OutlinedInput classes={{ input: classes.selectInput }} />}
              >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>  
      </Grid>
      <Grid container className={classes.gridSpacer} /> 
      <Grid container 
        justifyContent="flex-end"
      >
        <Button 
          onClick={() => handleCancel()}
          color="primary"
          variant="outlined"
          className={classes.button}
        >
          Cancel
        </Button>
        <Button 
          variant="contained"
          color="primary"
          size="small" 
          startIcon={<AddShoppingCartIcon/>}
          onClick={() => handleButtonClick()}
          className={classes.button}
        >
          Add
        </Button>
      </Grid>
    </>
  );
};

export default SearchResults;
